import { createSelector } from 'reselect';
import { getAreActivitiesEnabled } from 'lib/selectors/getAreActivitiesEnabled';
import { getLatestActivity } from 'lib/selectors/getLatestActivity';
import { getActivityTypes } from './getActivityTypes';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';

const getOpenActivity = createSelector(
  [getAreActivitiesEnabled, getLatestActivity],
  (areActivitiesEnabled, latestActivity) => {
    if (
      !areActivitiesEnabled ||
      !latestActivity ||
      latestActivity.end !== null
    ) {
      return null;
    }
    return latestActivity;
  }
);

const getOpenActivityTypeRef = createSelector(
  [getOpenActivity],
  (openActivity) => {
    return openActivity?.activityTypeRef;
  }
);

const getOpenActivityTypeMode = createSelector(
  [
    getOpenActivity,
    getActivityTypes,
    getCurrentLaborTicket,
    getPostLaborUpdatesOnNats,
  ],
  (openActivity, activityTypes, currentLaborTicket, natsFlowEnabled) => {
    // Async flow: use labor ticket type as the activity mode
    if (natsFlowEnabled && currentLaborTicket?.type) {
      return currentLaborTicket.type;
    }

    // Standard flow: get from actual activity
    return openActivity && activityTypes?.length
      ? activityTypes.find(({ activityTypeRef }) => {
          return activityTypeRef === openActivity?.activityTypeRef;
        })?.activityMode
      : null;
  }
);

export { getOpenActivity, getOpenActivityTypeRef, getOpenActivityTypeMode };
